var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('sidebar'),_c('div',{staticClass:"content"},[_c('symbols',{attrs:{"position":"top"}}),_c('transition',{staticClass:"route",attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{staticClass:"content-body"})],1)],1),_c('symbols',{attrs:{"position":"bottom"}})],1),_c('transitions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }